import type { IconSvgObject } from './types';

const AddInvoiceIcon: IconSvgObject = [
  ["path", { d: "M19 11.5V4C19 2.89543 18.1046 2 17 2H5C3.89543 2 3 2.89543 3 4V21.5L7 19.5L11 22L12.5 21.0625", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 11H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 14V22M21 18L13 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15 7L7 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default AddInvoiceIcon;
